import { CharityResponse } from "@/models/Content";
import baseApi from "./api.service";

const charityService = {
    getAvailableCharity(): Promise<CharityResponse[]> {
        return baseApi.get<CharityResponse[]>("charity/available");
    },
}

export default charityService;